export const SITE_SEAL_ENABLED_CLASS_NAME = 'enabled';
export const SITE_SEAL_DISABLED_CLASS_NAME = 'disabled';
export const FOOTER_SELECTOR = 'footer.footer';
